module.exports = __webpack_public_path__ + "static/media/3.b6c96c0b.jpg";